import { RouterProvider } from "react-router-dom";
import NavBar from "./Components/Organisms/NavBar/NavBar";
import Footer from "./Components/Organisms/Footer/Footer";
import { Routes } from "./Routes/Routes";
import { useEffect } from "react";
import ApiDocumentType from "./Core/Api/ApiHome/ApiDocumentType";
import { FeatureToken } from "./Core/Features/FeatureToken/FeatureToken";
import { closeSession, getUser, isActive } from "./Core/Features/FeatureGlobal";
import FeatureHomeLoginClubElite from "./Core/Features/FeaturesHome/FeatureHomeLoginClubElite"
import "./App.css";

function App() {
  const { Refresh } = FeatureToken();
  const { LoginClubElite } = FeatureHomeLoginClubElite();

  useEffect(() => {
    LoginClubElite()
    if (isActive()) {
      if(!getUser()?.idUsuario){
        closeSession()
        return
      }
      Refresh();
      return;
    }
    ApiDocumentType();
  }, []);


  return (
    <>
      <NavBar />
      <RouterProvider router={Routes} />
      <Footer />
    </>
  );
}

export default App;
